import { useQuery } from '@tanstack/react-query';

import { useLoader } from 'Store/loader';
import getRescheduleHosts from 'Api/reschedule/getRescheduleHosts';

import getRescheduleHostsResponse from './model/response/getRescheduleHostsResponse';

const useGetRescheduleHosts = (id) => {
  const { onShowLoader, onResetLoader } = useLoader();

  return useQuery({
    queryKey: ['reschedule-hosts-list', id],
    queryFn: async () => {
      onShowLoader({ variant: 'loader-primary' });

      const response = await getRescheduleHosts(id);

      const result = getRescheduleHostsResponse(response);

      onResetLoader();

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetRescheduleHosts;
